
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'phone': {
    width: 477.2,
    height: 477.1,
    viewBox: '0 0 477.2 477.1',
    data: '<path pid="0" d="M475 380.3l-2.4-7.2c-5.6-16.7-24.1-34.2-41-38.8l-62.7-17.1c-17-4.6-41.2 1.6-53.7 14L292.6 354c-82.5-22.3-147.1-86.9-169.4-169.4l22.7-22.7c12.4-12.4 18.7-36.7 14-53.7l-17.1-62.7c-4.6-17-22.1-35.4-38.8-41l-7.2-2.4c-16.7-5.6-40.6.1-53 12.5L10 48.6C3.9 54.6 0 71.9 0 72c-1.2 107.7 41.1 211.6 117.3 287.8 76 76 179.5 118.2 286.9 117.3.6 0 18.3-3.8 24.4-9.8l33.9-33.9c12.4-12.6 18.1-36.4 12.5-53.1z"/>'
  }
})
